// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"2866":"df6560bb8125b6aa2ee7","4151":"379c3ce560fe0270ffcb","5108":"379c3ce560fe0270ffcb"}[chunkId] + ".bundle.css";
};